module.exports = __webpack_public_path__ + "img/quizz-step-11-2.646aaa1e.jpg";